import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { Input } from 'antd';
import * as S from './styles';
import * as Style from 'components/Style';

export const ComponentInputTextArea = ({
  label,
  name,
  placeholder,
  control,
  onChange,
  maxLength,
  disabled,
  errors,
  rows,
  style,
  ...rest
}) => {
  const { TextArea } = Input;

  return (
    <S.InputContain id="ComponenteInputTextArea">
      {label && <S.Label>{label}</S.Label>}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <>
              <TextArea
                {...field}
                {...rest}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                onChange={onChange}
                rows={rows}
                data-testid="Input Text Area"
                style={{ ...style, resize: 'none' }}
              />
              {errors && errors[name] && <Style.GlobalErro>{errors[name]?.message}</Style.GlobalErro>}
            </>
          );
        }}
      />
    </S.InputContain>
  );
};

ComponentInputTextArea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  rows: PropTypes.number,
};

ComponentInputTextArea.defaultProps = {
  // label: null,
  // name: null,
  // placeholder: null,
  // control: {},
  // onChange: () => {},
  // maxLength: 4000,
  // disabled: false,
  // errors: {},
  // rows: 1,
};

export default ComponentInputTextArea;
